// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Search = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M3.807 11.1c1 1 2.216 1.5 3.646 1.5 1.43 0 2.645-.5 3.646-1.5 1.001-1.002 1.502-2.217 1.502-3.647 0-1.43-.5-2.645-1.502-3.646-1-1-2.216-1.501-3.646-1.501-1.43 0-2.645.5-3.646 1.501-1 1-1.501 2.216-1.501 3.646 0 1.43.5 2.645 1.501 3.646Zm10.51 1.5L20 18.285 18.284 20l-5.683-5.684v-.911l-.322-.322c-1.359 1.18-2.967 1.77-4.826 1.77-2.073 0-3.834-.715-5.281-2.145C.724 11.278 0 9.526 0 7.453S.724 3.62 2.172 2.172C3.619.724 5.38 0 7.453 0c2.073 0 3.825.724 5.255 2.172 1.43 1.447 2.145 3.208 2.145 5.281 0 1.859-.59 3.467-1.77 4.826l.322.322h.911Z"
			fill="#FFF"
			fillRule="evenodd"
		/>
	</svg>
);
export default Search;
